import NTopNBottom from '../../components/NTopNBottom'
import bannerImg from '../../assets/theGirl2022/banner.jpg'
import navColor from '../../assets/theGirl2022/nav/color.jpg'
import navBgFixed from '../../assets/theGirl2022/nav/nav_bg_fixed.png'
import navBg from '../../assets/theGirl2022/nav/top1_i1_nav.png'
import calcRemFn from '../calcRem'

const navCss = {
  navWrap: {
    paddingTop: 0,
    minHeight: calcRemFn(166),
    backgroundImage: `url(${navColor})`,
    boxSizing: 'border-box'
  },
  navCtn: {
    height: calcRemFn(166),
    backgroundImage: `url(${navBg})`,
    fun: 'changeBannerBg'
  },
  navCtnFixed: {
    height: calcRemFn(166),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    padding: `${calcRemFn(31)} ${calcRemFn(48)} 0 ${calcRemFn(48)}`,
  },
  topBtnBaseCss: {
    width: calcRemFn(81),
    height: calcRemFn(38),
    opacity: 0
  },
  bottomBtnLayout: {
    padding: `0 ${calcRemFn(40)}`,
    marginTop: calcRemFn(13),
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  bottomBtnBaseCss: {
    width: calcRemFn(48),
    height: calcRemFn(27),
    opacity: 0
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
    },
    {
      key: 'top2',
      show: true,
    },
    {
      key: 'top3',
      show: true,
    },
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
      },
      {
        key: '_i2',
        show: true,
      },
      {
        key: '_i3',
        show: true,
      },
      {
        key: '_i4',
        show: true,
      },
      {
        key: '_i5',
        show: true,
      },
      {
        key: '_i6',
        show: true,
      },
      {
        key: '_i7',
        show: true,
      },
      {
        key: '_i8',
        show: true,
      },
      {
        key: '_i9',
        show: true,
      },
      {
        key: '_i10',
        show: true,
      },
      {
        key: '_i11',
        show: true,
      }
    ]
  }
}

const pictureList = [
  {
    key: '1_1',
    pid: 102961,
    picNum: 2,
  },
  {
    key: '1_2',
    pid: 102961,
    picNum: 3
  },
  {
    key: '1_3',
    pid: 102961,
    picNum: 3
  },
  {
    key: '1_4',
    pid: 102961,
    picNum: 2
  },
  {
    key: '1_5',
    pid: 102961,
    picNum: 3
  },
  {
    key: '1_6',
    pid: 102961,
    picNum: 3
  },
  {
    key: '1_7',
    pid: 102961,
    picNum: 3
  },
  {
    key: '1_8',
    pid: 102961,
    picNum: 2
  },
  {
    key: '1_9',
    pid: 102961,
    picNum: 3,
  },
  {
    key: '1_10',
    pid: 102961,
    picNum: 3,
  },
  {
    key: '1_11',
    pid: 102961,
    picNum: 2,
  },
  {
    key: '2_1',
    pid: 102962,
    picNum: 11,
  },
  {
    key: '3_1',
    pid: 102963,
    picNum: 9,
  },
]

function handlePictures (pictureList) {
  const pictures = []
  pictureList.forEach(item => {
    const { picNum = 2, pid, key, startIndex = 0 } = item
    const picList = []
    Array(picNum).fill(0).forEach((item, index) => {
      picList.push(require(`../../assets/theGirl2022/ctn/${key}_${index + startIndex + 1}.jpg`))
    })
    const indexArr = key.split('_')
    pictures.push({
      id: pid,
      type: 'blue',
      ref: `top${indexArr[0]}_i${indexArr[1]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      son: picList
    })
  })
  return pictures
}
const pictures = handlePictures(pictureList)

function changeBannerBg(val, navRef) {
  const { far, son } = val
  navRef.style.backgroundImage = `url(${require(`../../assets/theGirl2022/nav/${far + son}_nav.png`)})`
}

function onChangeFun (_this) {
  _this.changeBannerBg = changeBannerBg
}


const topDiff = {
  firstSon: '_i1',
  top1_i5: 50,
  top1_i9: 50,
  top3_i1: 20,
}

export default {
  title: 'the girl',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  onChangeFun
}
